import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import nl2br from 'react-nl2br';
import { emojify } from 'react-emojione';

import { JournalEntryShape } from 'entities';

import './style.scss';

class JournalEntry extends Component {

  render() {
    const { isEmpty, journalEntry = { emoji: '', text: '' } } = this.props;
    const className = classnames('JournalEntry', {'is-empty': isEmpty});

    return (
      <div className={className}>
        <table>
          <tbody>
            <tr>
              <td>
                <span className="icon">{emojify(journalEntry.emoji, {output: 'unicode'})}</span><br />
                <span className="date">{moment(journalEntry.createdAt).fromNow()}</span>
              </td>
              <td>
                <p>{nl2br(emojify(journalEntry.text, {output: 'unicode'}))}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

JournalEntry.propTypes = {
  journalEntry: JournalEntryShape,
  isEmpty: PropTypes.bool,
  onJournalEntriesFetch: PropTypes.func
};

export default JournalEntry;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Journal/JournalEntry/index.js
 **/